export const INIT_SYMBOL_TIMEKEEPING = {
  code: "",
  name: "",
  loaiTinhCongs: []
}